import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Scroller from './../scroller'
const LlamadoAccion = ({ id }) => {
    return (
        <section id={id} className="page-section bg-llamado" >
            <Container>
                <Row className="justify-content-center">
                    <Col lg={8} className="text-center">
                        <h2 className="text-white mt-0">Automatice la gestión de cesiones de factoring’s, bolsas de productos, bancos, y otras empresas relacionadas de la industria financiera.</h2>
                        <br />
                        <a className="btn btn-light  js-scroll-trigger" href="#contacto" onClick={Scroller.handleAnchorScroll}>
                            Contáctese con nosotros
                        </a>

                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default LlamadoAccion
